// From Mueller.Business.Models\QuickLists\QuickListTemplateCode.cs

export const quickListTemplateCode = {
  appraisalCases: "AppraisalCases",
  insuranceCases: "InsuranceCases",
  customerInsuranceCases: "CustomerInsuranceCases",
  customerAppraisalCases: "CustomerAppraisalCases",
  homeownerOpenIncidents: "HomeownerOpenIncidents",
  customerReviewQueue: "CustomerReviewQueue",
  brokerFeedback: "BrokerFeedback",
  brokerCases: "BrokerCases",
  inspectorHiringForecastsOpen: "InspectorHiringForecastsOpen",
  caseFeedback: "CaseFeedback",
  appraiserQueue: "AppraiserQueue",
  qualityAssuanceInsurance: "QualityAssuanceInsurance",
  inspector: "Inspector",
  qualityAssuranceRequireAudit: "QualityAssuranceRequireAudit",
  appraiser: "Appraiser",
  qualityAssuranceAgent: "QualityAssuranceAgent",
};

export const nonCaseBasedTemplateCodes = [
  quickListTemplateCode.inspectorHiringForecastsOpen,
  quickListTemplateCode.inspector,
  quickListTemplateCode.appraiser,
  quickListTemplateCode.qualityAssuranceAgent,
];